import { MEMBER_TOKEN } from "../actions/const";

const initialState = {
  resetState: false,
  showModal: false,
  isLoadingAction: false,

  selectedData: null,
  formType: "",
  formId: "",
  formTitle: "",

  csvFile: null,

  form_memberId: '',
  form_cardType: '',

  memberId_isChecking: false,
  memberId_isExisting: false
};

function reducer (state = initialState, action) {
  let { type, payload } = action;

  switch (type) {
    case MEMBER_TOKEN:
      if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
        action.payload = {...initialState};
      }
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/MemberToken.js